<script>
import {
  SubscriptionCardElementMixin,
} from "%/dynamic-component-editor/standard-components/subscription-card/subscription-card-element-mixin";
import { billingFrequencyUnit } from "%/dynamic-component-editor/standard-components/plan-sheet/plan-sheet-state";
import TextElement
  from "%/dynamic-component-editor/standard-elements/text-element/TextElement.vue";

export default {
  name: "SubscriptionPlanBillingFrequency",
  extends: TextElement,
  mixins: [SubscriptionCardElementMixin],
  elementPanelSettings: {
    displayName: "Billing Frequency",
    displayIcon: "text-alt",
    elementGroup: "subscriptionElements",
    elementType: "element",
  },
  computed: {
    isEditable() {
      return false;
    },
    value() {
      const price = this.entity?.price ?? 0;
      return `$${price} / ${billingFrequencyUnit(this.entity?.billingFrequency)}`;
    },
  },
};
</script>
